"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKDataGridWrapper = exports.GKDataGridWrapperContext = void 0;
var React = __importStar(require("react"));
var use_resize_observer_1 = __importDefault(require("use-resize-observer"));
var debounce_1 = __importDefault(require("lodash/debounce"));
/**
 * Provides a context for tracking width and height of the data grid.
 * These are used by virtualization to determine which rows are visible.
 * Note: We're currently only using height
 */
exports.GKDataGridWrapperContext = React.createContext({});
/**
 * Provides the "table" wrapper for GKDataGrid. This component handles
 * setting proper grid heights for virtualization when requested.
 */
var GKDataGridWrapper = function (props) {
    var _a;
    var children = props.children, virtualize = props.virtualize, getTableProps = props.getTableProps, qaProp = props["data-qa"], otherProps = __rest(props, ["children", "virtualize", "getTableProps", "data-qa"]);
    var _b = React.useState(0), gridHeight = _b[0], setGridheight = _b[1];
    // Refs to track changes to the grid.
    var gridWrapperRef = React.useRef(null);
    var gridParent = (_a = gridWrapperRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
    var debounceHeight = React.useCallback((0, debounce_1.default)(setGridheight, 250), []);
    // Observe changes to the grid parent's size.
    (0, use_resize_observer_1.default)({
        onResize: function (_a) {
            var _b;
            var _c = _a.height, height = _c === void 0 ? 0 : _c;
            return debounceHeight(height - (((_b = gridWrapperRef.current) === null || _b === void 0 ? void 0 : _b.offsetTop) || 0));
        },
        ref: gridParent,
    });
    if (!virtualize) {
        return (React.createElement("div", __assign({}, getTableProps(otherProps), { "data-qa": qaProp }), children));
    }
    return (React.createElement(exports.GKDataGridWrapperContext.Provider, { value: { height: gridHeight } },
        React.createElement("div", __assign({}, getTableProps(otherProps), { "data-qa": qaProp, style: { height: gridHeight }, ref: gridWrapperRef }), children)));
};
exports.GKDataGridWrapper = GKDataGridWrapper;
exports.default = exports.GKDataGridWrapper;
